var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrillDownBlueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29829 3.98826C2.01567 3.68545 1.54108 3.66908 1.23826 3.95171C0.935451 4.23433 0.919086 4.70893 1.20171 5.01174C2.28082 6.16088 3.4106 7.31576 4.675 8.26406C5.12105 8.5986 5.66658 9 6.25 9C6.83342 9 7.37896 8.5986 7.825 8.26406C9.0968 7.31021 10.2158 6.17102 11.2982 5.01186C11.5808 4.70904 11.5646 4.23433 11.2617 3.95171C10.9589 3.66908 10.4843 3.68545 10.2017 3.98826C9.18246 5.0769 8.11907 6.16851 6.925 7.06406C6.70587 7.22841 6.52096 7.35027 6.37631 7.42776C6.26434 7.48774 6.23566 7.48774 6.1237 7.42776C5.97905 7.35027 5.79414 7.22841 5.575 7.06406C4.38142 6.16888 3.31685 5.07274 2.29829 3.98826Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrillDownBlueArrow);
export default __webpack_public_path__ + "static/media/drillDownBlueArrow.dd18b1ed1c51ea5c3ee322649c5fd8af.svg";
export { ForwardRef as ReactComponent };